import { NextPage, GetServerSideProps } from "next";
import Head from "next/head";
// Components
import { NoHeader } from "../../../components/templates";
import { MainForgotPassword } from "../../../components/organisms";
// configs
import { routesName } from "../../../configs";
// Utils
import { setRoute } from "../../../utils";

const ForgotPassword: NextPage = () => {
  return (
    <NoHeader>
      {/* SEO */}
      <Head>
        <title>Foodizmart: Forgot Password</title>
      </Head>

      {/* Content */}
      <MainForgotPassword />
    </NoHeader>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;

  const { _xSe } = req.cookies;

  if (_xSe) {
    return {
      redirect: {
        destination: setRoute(routesName.TRANSACTION),
        permanent: false,
      },
    };
  }

  return { props: {} };
};

export default ForgotPassword;
